// extracted by mini-css-extract-plugin
module.exports = {"search-button":"SearchBox_search-button__TxMG-","search-form":"SearchBox_search-form__1j2yg"};